module.exports = __webpack_public_path__ + "static/media/individual-recipient-added.2f8b1577.png";